import { css } from '@emotion/core';
import { Theme } from 'features/Theme';
import { helpText } from 'features/Theme/mixins';

const styles = {
  containedButton: css`
    display: flex;
    justify-content: center;
    margin-top: 12px;
    margin-bottom: 12px;
  `,

  walletButtonsContainer: (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    ${theme.mui.breakpoints.up('md')} {
      flex-direction: row;
    }
  `,
  walletButton: (theme: Theme) => css`
    padding: 0 ${theme.mui.spacing(1)}px;
  `,
  finePrint: (theme: Theme) => css`
    ${helpText(theme)};
    p {
      ${helpText(theme)};
    }
  `,
};

export default styles;
